<template>
    <CSidebar
        fixed
        :minimize="minimize"
        :show="show"
        @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
        <CSidebarBrand class="d-md-down-none" to="/">
            <!--            <h4>MasterKala ERP</h4>-->
            <img src="../assets/img/small.png">
            <!--            <CIcon-->
            <!--                    class="c-sidebar-brand-full"-->
            <!--                    name="logo"-->
            <!--                    size="custom-size"-->
            <!--                    :height="35"-->
            <!--                    viewBox="0 0 556 134"-->
            <!--            />-->
        </CSidebarBrand>
        <CRenderFunction flat :content-to-render="menus"/>
        <!--        <CSidebarMinimizer-->
        <!--                class="d-md-down-none"-->
        <!--                @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"-->
        <!--        />-->
    </CSidebar>
</template>

<script>
    export default {
        name: 'TheSidebar',
        data() {
            return {
                menus: []
            }
        },
        computed: {
            show() {
                return this.$store.state.sidebarShow
            },
            minimize() {
                return this.$store.state.sidebarMinimize
            }
        },
        beforeMount() {
            this.loadNavBar()
        },
        methods: {
            typeToIcon(menuType) {
                let iconName = '';
                switch (menuType) {
                    case 'dashboard':
                        iconName = 'cil-speedometer';
                        break;
                    case 'setting':
                        iconName = 'cil-settings';
                        break;
                    case 'catalog':
                        iconName = 'cil-description';
                        break;
                    case 'report':
                        iconName = 'cil-report';
                        break;
                    case 'sell':
                        iconName = 'cil-inbox-out';
                        break;
                    case 'banking':
                        iconName = 'cil-bank';
                        break;
                    case 'buy':
                        iconName = 'cil-inbox-in';
                        break;
                }
                return iconName
            },
            loadNavBar() {
                let finalNavBar = {
                    _name: 'CSidebarNav',
                    _children: []
                };
                this.$http.post(this.$hostname + 'user/getmenu', {}, {
                    headers: {
                        "metoken": localStorage.getItem('token')
                    }
                }).then((response) => {
                    let menuItems = response.body;
                    for (let i = 0; i < menuItems.length; i++) {
                        let menuItem = {
                            _name: 'CSidebarNavItem',
                            name: menuItems[i].name,
                            to: '/' + menuItems[i].route,
                            icon: this.typeToIcon(menuItems[i].route)
                        };
                        if (menuItems[i].submenu) {
                            if (menuItems[i].submenu.length > 0) {
                                menuItem['_name'] = 'CSidebarNavDropdown';
                                menuItem['items'] = [];
                                for (let submenuItem = 0; submenuItem < menuItems[i].submenu.length; submenuItem++) {
                                    menuItem.items.push({
                                        name: menuItems[i].submenu[submenuItem].name,
                                        to: '/' + menuItems[i].route + '/' + menuItems[i].submenu[submenuItem].route
                                    })
                                }
                            }
                        }
                        finalNavBar._children.push(menuItem)
                    }
                    this.menus = [finalNavBar]
                });
            }
        }
    }
</script>
